(function () {
    function initHeroCarousel(container) {
        if (!container || container.dataset.initialized === 'true') return;
        container.dataset.initialized = 'true';

        const slides = container.querySelectorAll('.hero-carousel-slide');
        const dots = container.querySelectorAll('.carousel-dot');
        const prevBtn = container.querySelector('.prev-btn');
        const nextBtn = container.querySelector('.next-btn');
        const wrapper = container.querySelector('.hero-carousel-wrapper--adapt');
        const mainWrapper = container.querySelector('.hero-carousel-wrapper');
        if (mainWrapper && !wrapper) {
            mainWrapper.style.aspectRatio = '';
        }

        function updateWrapperRatio(slide) {
            if (!wrapper || !slide) return;
            const isMobile = window.innerWidth <= 768;
            const ratio = isMobile
                ? (slide.dataset.aspectRatioMobile || slide.dataset.aspectRatio)
                : slide.dataset.aspectRatio;

            if (ratio && parseFloat(ratio) > 0) {
                wrapper.style.aspectRatio = ratio;
            }
        }

        if (slides.length <= 1) {
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
            const dotsContainer = container.querySelector('.carousel-dots');
            if (dotsContainer) dotsContainer.style.display = 'none';
            if (slides[0]) updateWrapperRatio(slides[0]);
            return;
        }

        let currentIndex = 0;
        let autoplayTimer = null;

        if (slides[currentIndex]) {
            updateWrapperRatio(slides[currentIndex]);
        }

        function goToSlide(index) {
            slides[currentIndex].classList.remove('active');
            if (dots[currentIndex]) dots[currentIndex].classList.remove('active');

            currentIndex = (index + slides.length) % slides.length;

            slides[currentIndex].classList.add('active');
            if (dots[currentIndex]) dots[currentIndex].classList.add('active');

            updateWrapperRatio(slides[currentIndex]);
        }

        window.addEventListener('resize', function () {
            const activeSlide = container.querySelector('.hero-carousel-slide.active');
            if (activeSlide) updateWrapperRatio(activeSlide);
        });

        if (nextBtn) {
            nextBtn.addEventListener('click', function (e) {
                e.preventDefault();
                goToSlide(currentIndex + 1);
                resetAutoplay();
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function (e) {
                e.preventDefault();
                goToSlide(currentIndex - 1);
                resetAutoplay();
            });
        }

        dots.forEach(function (dot, idx) {
            dot.addEventListener('click', function (e) {
                e.preventDefault();
                goToSlide(idx);
                resetAutoplay();
            });
        });

        const isAutoplay = container.dataset.autoplay !== 'false';
        const interval = parseInt(container.dataset.interval, 10) || 5000;

        function startAutoplay() {
            if (isAutoplay && slides.length > 1) {
                autoplayTimer = setInterval(function () {
                    goToSlide(currentIndex + 1);
                }, interval);
            }
        }

        function resetAutoplay() {
            if (autoplayTimer) clearInterval(autoplayTimer);
            startAutoplay();
        }

        startAutoplay();
    }

    function initAllCarousels() {
        const containers = document.querySelectorAll('.hero-carousel-container');
        containers.forEach(function (container) {
            initHeroCarousel(container);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllCarousels);
    } else {
        initAllCarousels();
    }

    document.addEventListener('shopify:section:load', function (e) {
        if (e.target) {
            const containers = e.target.querySelectorAll('.hero-carousel-container');
            containers.forEach(function (container) {
                initHeroCarousel(container);
            });
        }
    });
})();